import { render, staticRenderFns } from "./TestimonialsEditor.vue?vue&type=template&id=969cb4da"
import script from "./TestimonialsEditor.vue?vue&type=script&lang=js"
export * from "./TestimonialsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports